__turbopack_context__.v({
  "card": "OutfitGrid-module__143ySW__card",
  "cardContent": "OutfitGrid-module__143ySW__cardContent",
  "imageWrapper": "OutfitGrid-module__143ySW__imageWrapper",
});
